import React, { ReactNode } from 'react';
import styles from './PageHeader.module.scss';

interface PageHeaderProps {
    /** Main page heading. */
    title: string;
    /** Supporting copy shown under the heading. */
    subtitle?: string;
    /** Page-specific controls, such as search or filters. */
    children?: ReactNode;
}

/** Shared public-page title block for list/search style pages. */
const PageHeader = ({ title, subtitle, children }: PageHeaderProps) => (
    <section className={styles.header}>
        <div className={styles.inner}>
            <div className={styles.copy}>
                <h1>{title}</h1>
                {subtitle ? <p>{subtitle}</p> : null}
            </div>
            {children ? <div className={styles.actions}>{children}</div> : null}
        </div>
    </section>
);

export default PageHeader;
